// src/components/PaginasAjuda.jsx
// Páginas públicas de ajuda: política de reembolso e exclusão de conta.
// Texto da política de reembolso confirmado pelo advogado em 13/10/2026 (7 dias, inclusive Entry). Prazo de 10 dias úteis = sugestão da minuta, não contestada.
import React from 'react';

function Casca({ titulo, atualizadoEm, children }) {
  return (
    <div className="min-h-screen bg-black text-white/90 px-6 py-12">
      <div className="max-w-3xl mx-auto">
        <a href="/" className="text-xs uppercase tracking-widest text-white/40 hover:text-white/70 transition-colors">
          ← Voltar
        </a>
        <h1 className="text-2xl md:text-3xl font-black text-white mt-6 mb-2">{titulo}</h1>
        <p className="text-xs text-white/40 mb-10">Última atualização: {atualizadoEm}</p>
        <div className="space-y-6 text-sm leading-relaxed text-white/80 [&_h2]:text-white [&_h2]:font-bold [&_h2]:text-base [&_h2]:mt-8 [&_h2]:mb-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:space-y-1">
          {children}
        </div>
      </div>
    </div>
  );
}

export function PoliticaDeReembolso() {
  return (
    <Casca titulo="Política de Reembolso — Phoenix OS" atualizadoEm="12/10/2026">
      <p>
        Você pode pedir o reembolso em até <strong>7 dias corridos</strong> da contratação, tanto de assinaturas
        quanto do relatório avulso (Phoenix Entry).
      </p>

      <h2>Como pedir</h2>
      <p>
        Envie um e-mail para <a className="underline text-white" href="mailto:suporte@phoenixos.com.br">suporte@phoenixos.com.br</a>{' '}
        com o e-mail da sua conta e a data da compra.
      </p>

      <h2>Como devolvemos</h2>
      <p>
        Devolvemos o valor pelo mesmo meio de pagamento em até <strong>10 dias úteis</strong> do pedido. Ao devolver,
        o acesso ao plano ou ao relatório é encerrado.
      </p>

      <h2>Depois dos 7 dias</h2>
      <p>
        Você pode cancelar a assinatura quando quiser, pelo aplicativo ou pelo painel. O cancelamento interrompe as
        cobranças futuras e você mantém o acesso até o fim do período já pago, sem reembolso proporcional.
      </p>
      <ul>
        <li>Os relatórios que você comprou pelo Phoenix Entry continuam acessíveis.</li>
        <li>Os relatórios gerados durante o plano ficam bloqueados (não são apagados) e voltam a abrir se você assinar de novo.</li>
      </ul>

      <h2>Mais informações</h2>
      <p>
        Veja também os <a className="underline text-white" href="/termos-de-uso">Termos de Uso</a> e a{' '}
        <a className="underline text-white" href="/politica-de-privacidade">Política de Privacidade</a>.
      </p>
    </Casca>
  );
}

export function ExcluirConta() {
  return (
    <Casca titulo="Como excluir sua conta e seus dados — Phoenix OS" atualizadoEm="12/10/2026">
      <p>Você pode excluir a sua conta do Phoenix OS e os seus dados a qualquer momento.</p>

      <h2>Pelo aplicativo</h2>
      <ol>
        <li>Abra o aplicativo e entre na sua conta.</li>
        <li>Vá em <strong>Perfil</strong> e depois em <strong>Configurações da conta</strong>.</li>
        <li>Toque em <strong>Excluir minha conta</strong> e confirme.</li>
      </ol>
      <p>
        A exclusão cancela as suas assinaturas na hora e apaga os seus relatórios, o seu perfil e o seu login.
        Não é possível desfazer.
      </p>

      <h2>Por e-mail</h2>
      <p>
        Se preferir, envie um e-mail para <a className="underline text-white" href="mailto:suporte@phoenixos.com.br?subject=Excluir%20conta">suporte@phoenixos.com.br</a>{' '}
        com o assunto <strong>"Excluir conta"</strong>, a partir do e-mail cadastrado na conta. Faremos a exclusão no prazo previsto em lei.
      </p>

      <h2>O que pode ser mantido</h2>
      <p>
        Dados de cobrança podem ser mantidos pelo prazo exigido por obrigações legais e fiscais. Mais detalhes na{' '}
        <a className="underline text-white" href="/politica-de-privacidade">Política de Privacidade</a>.
      </p>
    </Casca>
  );
}
